export default __webpack_public_path__ + "static/media/node-expand.7c0c5906.svg";